module.exports = __webpack_public_path__ + "img/item1.6bc5f9e2.png";